const Success = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="19"
            fill="none"
            viewBox="0 0 26 19"
            {...props}
        >
            <path
                fill="#000"
                d="M23.694.016c-.465.06-.894.277-1.217.614L8.744 14.243 3.341 9.966a2.058 2.058 0 00-1.511-.44 2.064 2.064 0 00-1.38.751 2.027 2.027 0 00-.437 1.5 2.021 2.021 0 00.765 1.365l6.834 5.42a2.062 2.062 0 002.734-.17L25.38 3.488a2.016 2.016 0 00.416-2.337 2.04 2.04 0 00-.867-.904 2.066 2.066 0 00-1.236-.231z"
            />
        </svg>
    )
}

export default Success
